import { render } from "./BrushMapSelectTooth.vue?vue&type=template&id=14d32a76&scoped=true"
const script = {}

import "./BrushMapSelectTooth.vue?vue&type=style&index=0&id=14d32a76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d32a76"]])

export default __exports__